<template>
  <section :class="[loadingClass, 'cart']">
    <div class="loading-icon" />

    <div class="order-items">
      <OrderItem
        v-for="item in order.items"
        :key="item.id"
        :cartversion="order.cart_version"
        :item="item"
        :showhotels="order.event_hotel_behavior"
      />
    </div>

    <CurrencySelection
      :chargecurrency="order.charge_currency"
      :chargeablecurrencies="order.chargeable_currencies"
    />

    <DiscountForm
      v-if="notCheckoutCart"
      :activediscounts="order.active_discounts"
    />
    <GPTDisplay
      :order="order"
    />
    <AmountDisplay
      v-if="order.discount > 0"
      extraclass="discount"
      :header="$t(&quot;formPackage.discount&quot;)"
      :amount="&quot;(&quot; + order.discount_decorated + &quot;)&quot;"
    />

    <AmountDisplay
      v-if="order.h4h_points > 0"
      extraclass="h4h-program"
      :header="order.h4h_program"
      :amount="&quot;(&quot; + order.h4h_points_decorated + &quot;)&quot;"
    />
    <AmountDisplay
      v-if="refundableBooking"
      extraclass="protect-group-fee"
      :header="$t(&quot;checkout.protectGroup.refundableBooking&quot;)"
      :amount="order.protect_group_amount"
    />

    <AmountDisplay
      v-if="creditUsed && order.customer_total_credit > 0"
      extraclass="cart-footer credit-amount negative-amount"
      :header="$t(&quot;cart.credit&quot;)"
      :amount="`(${order.credit_amount_decorated})`"
    />

    <AmountDisplay
      v-if="order.tax > 0"
      extraclass="tax"
      :header="$t(&quot;cart.tax&quot;)"
      :amount="order.tax_decorated"
    />

    <AmountDisplay
      v-if="order.vat_tax > 0"
      extraclass="vat-tax"
      :header="$t(&quot;cart.vatTax&quot;)"
      :amount="order.vat_tax_decorated"
    />

    <AmountDisplay
      extraclass="fee"
      :header="$t(&quot;cart.processingFee&quot;)"
      :amount="order.processing_fee_decorated"
    />

    <AmountDisplay
      extraclass="fee-and-tax"
      :header="$t(&quot;cart.processingFeeTax&quot;)"
      :amount="order.fee_and_tax_decorated"
    />


    <div class="total-charge">
      <AmountDisplay
        extraclass="total"
        :header="$t(&quot;cart.yourTotal&quot;)"
        :amount="order.amount_after_credit"
      />

      <CurrencyDisclaimer
        :currency="order.charge_currency"
        :chargeablecurrencies="order.chargeable_currencies"
      />
    </div>

    <div class="total-exchange">
      <AmountDisplay
        extraclass="total"
        :header="$t(&quot;cart.yourTotal&quot;)"
        :amount="order.total_exchange_decorated"
      />

      <CurrencyDisclaimer
        :currency="order.currency"
        :chargeablecurrencies="order.chargeable_currencies"
      />
    </div>
  </section>
</template>

<script>
import AmountDisplay from './amount_display'
import CurrencyDisclaimer from '../../default/currency_convert/currency-disclaimer'
import CurrencySelection from './currency_selection'
import DiscountForm from './discount_form'
import GPTDisplay from './gpt_display'
import OrderItem from './order_items/order_item'
import { mapMutations } from 'vuex'

export default {
  components: {
    AmountDisplay,
    CurrencyDisclaimer,
    CurrencySelection,
    DiscountForm,
    GPTDisplay,
    OrderItem,
  },

  props: ['order', 'loading'],

  computed: {
    hasPaymentTerms() {
      return !(this.order.event_payment_term_options.slice(-1)[0] == 1)
    },
    notCheckoutCart(){
      return this.$store ? false : true
    },
    loadingClass() {
      return (this.loading ? 'loading' : '')
    },
    refundableBooking(){
      return this.order.protect_group_amount_raw > 0
    },
    negativeAmount(){
      return this.order.credit_amount_decorated
    },
    customerTotalDecorated(){
      return this.order.customer_total_credit_decorated
    },
    creditUsed: {
      get() {
        if(this.$store){
          return this.$store.state.checkout.applyCredit
        }

        return false
      },
      set() {
        this.toggleCreditApplication()
      }
    }
  },


  methods: {
    ...mapMutations('checkout', ['toggleCreditApplication']),
  }
}
</script>
